import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-bestand',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './bestand.component.html',
  styleUrl: './bestand.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BestandComponent {

}
